import React from "react"
import { useIsMobile } from "../../hooks/useIsMobile"
import { getIsSsrMobile } from "../../utils/getIsSsrMobile"
import LandingAppBar from "../../components/layout/landing/desktop/app-bar"
import Head from "next/head"
import { useRouter } from "next/router"
import { CREDIT_LAYER_ENUM } from "../../services/requests/types"

const LoanGuide = () => {
  const router = useRouter()
  const layerId = router?.query?.creditLayerId || ""
  const isMobile = useIsMobile()

  const LOAN_GUIDE_IMAGES = {
    [CREDIT_LAYER_ENUM.AIR_CONDITIONER]: {
      desktop: "/air-conditioner-loan-guide-desktop.svg",
      mobile: "/air-conditioner-loan-guide-mobile.svg"
    }
  }
  const guideImages = layerId
    ? LOAN_GUIDE_IMAGES[CREDIT_LAYER_ENUM.AIR_CONDITIONER]
    : {
        desktop: "/loanGuidDesktop.svg",
        mobile: "/loanGuidMobile.svg"
      }
  return (
    <>
      <Head>
        <title>مراحل ثبت درخواست تسهیلات</title>
      </Head>
      <div style={{ backgroundColor: "rgb(40 42 58)" }}>
        <LandingAppBar />
      </div>
      <img src={isMobile ? guideImages.mobile : guideImages.desktop} alt='راهنمای دریافت وام' />
    </>
  )
}

export default LoanGuide

export async function getServerSideProps(context = GetServerSidePropsContext) {
  return {
    props: {
      isSsrMobile: getIsSsrMobile(context)
    }
  }
}
